import React from 'react';
import {HashRouter, Switch, Route} from 'react-router-dom';
import Main from './pages/main';
import Cometa from './pages/cometa';


const Routes = () => (

    <HashRouter>
        <Switch>
            <Route exact path="/" component={Main}></Route>
            <Route path="/cometas/:id" component={Cometa}></Route>
        </Switch>
    
    </HashRouter>

)

export default Routes;